import { useState, useCallback } from 'react'
import logger from '../utils/logger'

/**
 * Custom hook for handling realtime presence tracking
 * @param {string} pollId - The poll ID for logging
 * @returns {Object} Presence state and handlers
 */
function useRealtimePresence(pollId) {
    const [activeViewers, setActiveViewers] = useState(0)

    /**
     * Handle presence sync event from Supabase channel
     * @param {Object} channel - The Supabase channel to get presence state from
     */
    const handlePresenceSync = useCallback((channel) => {
        const state = channel.presenceState()
        const viewerCount = Object.keys(state).length
        setActiveViewers(viewerCount)
        logger.debug('Presence sync', { pollId, viewerCount })
    }, [pollId])

    /**
     * Reset active viewers (e.g., on disconnect)
     */
    const resetActiveViewers = useCallback(() => {
        setActiveViewers(0)
    }, [])

    return {
        activeViewers,
        setActiveViewers,
        handlePresenceSync,
        resetActiveViewers
    }
}

export default useRealtimePresence
